import axios from 'axios';

var nextToLogin = (userResult) => {
  window.location.href = window.auth.redirectLogin;
};

var auth = {
  config: (options = {}) => {
    options = {
      ...{
        redirectLogin: '/#/admin',
        redirectNotLogin: '/#/',
        redirectNotAuthorization: '/#/notRole',
      },
      options,
    };

    window.auth = options;

    var _this = this;

    //Iniciar la authorización si existe al inicio
    if (localStorage.getItem('token')) {
      axios.defaults.headers.common['Authorization'] =
        localStorage.getItem('token');
    }

    // Add a response interceptor
    axios.interceptors.response.use(
      function (response) {
        // Do something with response data
        return response;
      },
      function (error) {
        console.log('error', error.response);
        // Do something with response error
        if (error.response.status === 401) {
          console.log('Unauthorized');
          auth.logout();
        }

        if (error.response.status === 403) {
          console.log('Not Role for this');
          auth.redirectNotAuthorization();
        }

        return Promise.reject(error.response);
      }
    );

    window.auth = options;
  },
  getConfig: () => {
    return window.auth;
  },
  redirectNotAuthorization: () => {
    console.log('no autorizado a entrar aquí');
    window.location.href = window.auth.redirectNotAuthorization;
  },
  setCurrentUser: (user) => {
    localStorage.setItem('user', user);
  },
  getCurrentUser: () => {
    let currentUser = JSON.parse(localStorage.getItem('user'));
    return currentUser;
  },
  can: (rolesCan) => {
    var can = false;
    var user = auth.getCurrentUser();

    if (user !== null) {
      user.roles.map((role) => {
        if (rolesCan.includes(role)) {
          can = true;
        }
      });
      return can;
    } else {
      return can;
    }
  },
  canAccess: (roles = []) => {
    if (auth.isLogin()) {
      if (!auth.can(roles)) {
        auth.redirectNotAuthorization();
      }
    } else {
      auth.logout();
    }
  },
  onLogin: (token, userId = '') => {
    localStorage.setItem('token', token);
    localStorage.setItem('userId', userId);
    axios.defaults.headers.common['Authorization'] = token;
  },
  getLogin: () => {
    var token = localStorage.getItem('token');
    var userId = localStorage.getItem('userId');
    return { token, userId };
  },
  login: (email, password, nextToLogin = nextToLogin) => {
    return new Promise(async (resolve, reject) => {
      try {
        var loginResult = await axios.post(
          process.env.REACT_APP_URL_API + '/api/users/login',
          {
            email: email,
            password: password,
          }
        );

        var params = {
          include: ['roles'],
        };
        var userResult = await axios.get(
          process.env.REACT_APP_URL_API +
            '/api/users/' +
            loginResult.data.userId +
            '?filter=' +
            JSON.stringify(params),
          { headers: { Authorization: loginResult.data.id } }
        );

        var roles = [];
        if (userResult.data.roles !== undefined) {
          userResult.data.roles.map((role) => roles.push(role.name));
          userResult.data.roles = roles;
        } else {
          userResult.data.roles = [];
        }

        auth.onLogin(loginResult.data.id, loginResult.data.userId);
        auth.setCurrentUser(JSON.stringify(userResult.data));

        nextToLogin(userResult.data);

        resolve();
      } catch (e) {
        if (
          e.message === 'Request failed with status code 400' ||
          e.message === 'Request failed with status code 401'
        ) {
          reject('Email o contraseña incorrectos');
        } else {
          reject('Error al iniciar');
        }
      }
    });
  },
  isLogin: () => {
    if (localStorage.getItem('token') !== null) {
      let currentUser = auth.getCurrentUser();
      if (currentUser === null) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  },
  verifyLogin: () => {
    if (!auth.isLogin()) {
      auth.logout();
      return false;
    } else {
      return true;
    }
  },
  verifyRealLogin: () => {
    // TODO hacer una verificación directamente en el servidor.
  },
  logout: (redirect = window.auth.redirectNotLogin) => {
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.removeItem('role');
    localStorage.removeItem('user');
    axios.defaults.headers.common['Authorization'] = undefined;
    if (redirect !== false) {
      window.location.href = redirect;
    }
  },
};

export default auth;



// WEBPACK FOOTER //
// ./src/lib/auth.js